import { Component } from '@angular/core';

@Component({
  selector: 'lib-component-library',
  standalone: true,
  imports: [],
  template: `
    <p>
      component-library works!
    </p>
  `,
  styles: ``
})
export class ComponentLibraryComponent {

}
